<template lang="html">
    <div class="detail-journeys">
        <simple-journey v-if="!journeyId" :is-summary="isSummary" :journeyData="journeyData"></simple-journey>
        <journey-overview v-else :journeyId="journeyId"></journey-overview>
    </div>
</template>

<script>
import SimpleJourney from '@/components/detail/tabView/SimpleJourney'
import JourneyOverview from '@/components/detail/tabView/JourneyOverview'

export default {
    name: 'journey',
    props: {
        isSummary: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        journeyData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
        }
    },
    computed: {
        journeyId () {
            return this.$store.state.detail && this.$store.state.detail.baseInfo && this.$store.state.detail.baseInfo.journeyEditId || 0;
        }
    },
    components: {
        SimpleJourney,
        JourneyOverview
    }
}
</script>

<style lang="scss">
@import '../../style/common.scss';

.detail-journeys {
    margin-bottom: 22px;
    .loading {
        position: relative;
        height: 450px;
        background-color: #fff;
    }

    .journeys-main {
        padding-top: 10px;
    }
    .journeys-info {
        margin-bottom: 9px;
        padding: 15px 15px 4px;
        background-color: #fff;
        font-size: 12px;
        line-height: 16px;
        dl {
            margin-bottom: 9px;
            dt {
                float: left;
                color: #999;
                i {
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    border-radius: 50%;
                    background-color: #f80;
                    margin-right: 5px;
                    margin-bottom: 1px;
                }
            }
            dd {
                margin-left: 60px;
                color: #222;
            }
        }
    }
    /*-------------行程tab e--------------*/

    /*-------------行程详情 s--------------*/
    .journeys-dt {
        > ul {
            > li {
                padding: 0;
                background-color: #fff;
                margin-bottom: 9px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
        &-head {
            text-align: center;
            &-day {
                background-color: $greenColor;
                display: inline-block;
                width: 90px;
                height: 28px;
                font-size: 16px;
                color: #fff;
                line-height: 28px;
                text-align: center;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
            }
            &-line {
                padding: 20px 0;
                font-size: 26px;
                line-height: 34px;
                color: #222;
                border-bottom: 1px solid rgba(0, 0, 0, .05);
            }
        }
        &-container {
            margin-top: 15px;
        }
        &-item {
            padding: 0 0 10px 18px;
            border-left: 1px dashed #ddd;
            &:last-child {
                border-left: 0;
            }
        }
        &-info {
            font-size: 12px;
            line-height: 12px;
            color: #999;
        }
        &-remark {
            font-size: 12px;
            line-height: 18px;
            color: #666;
        }
        &-reminder {
            font-size: 12px;
            line-height: 18px;
            color: $greenColor;
            padding-bottom: 3px;
        }
        &-pic {
            float: left;
            position: relative;
            width: 100%;
            margin-bottom: 10px;
            img {
                height: 100%;
                touch-action: manipulation;
                background :#e6e6e6;
                border-radius: 9px;
            }
            p {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 20px;
                background-color: rgba(0,0,0,.35);
                font-size: 14px;
                color: #fff;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-indent: 6px;
            }
        }
        &-imgs-1,
        &-imgs-3,&-imgs-2,
        &-imgs-4 {
            margin-top: 8px;
            @include clearfix;
            .journeys-dt-pic {
                &:nth-child(odd) {
                    width: 100%;
                    img {
                        width: 100%;
                        height: auto;
                        /*top: 50%;
                        left: 0;
                        -webkit-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        transform: translateY(-50%);*/
                    }
                }
                &:nth-child(even) {
                    width: 100%;
                    img {
                        width: 100%;
                        height: auto;
                        /*top: 50%;
                        left: 0;
                        -webkit-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        transform: translateY(-50%);*/
                    }
                }
            }
        }
    }
    .journeys-rm {
        padding: 0 15px;
        font-size: 14px;
        line-height: 21px;
        color: #666;
        background-color: #fff;
        &-title {
            padding-top: 20px;
            font-size: 16px;
            color: #222;
            text-align: center;
        }
        &-tips {
            padding-top: 15px;
        }
        &-addition {
            padding: 15px 0 24px;
        }
    }
    /*-------------行程详情 e--------------*/

    /*-------------行程概要 s--------------*/
    .journeys-summary {
        padding-top: 10px;
        .journeys-dt > ul > li {
            margin-bottom: 0;
        }
        .journeys-info {
            margin-bottom: 0;
        }
        .journeys-dt-container {
            padding: 12px 8px 0;
            background-color: #fff;
            margin: 0 0 12px;
            
        }
        .journeys-dt-item {
            padding:0 0 0 18px;
            border-left: 1px dotted #dcf4e2;
        }
        .dt-item {
            &-title {
                position: relative;
                display: inline-block;
                margin-bottom: 1px;
                font-size: 16px;
                font-weight: 700;
                line-height: 20px;
                color: $greenColor;
                color: #222;
                .dt-item-day {
                    float: left;
                    color: $greenColor;
                }
                p {
                    float: left;
                    margin-left: 14px;
                }
                .dt-icon-traffic-t {
                    font-size: 12px;
                    color: rgba(95,100,110,.4);
                }
                .dt-icon-summary {
                    position: absolute;
                    top: -1px;
                    left: -23px;
                    width: 11px;
                    height: 11px;
                    padding: 0;
                    background: #fff;
                    i {
                        position: absolute;
                        top: 4px;
                        left: 0;
                        width: 5px;
                        height: 5px;
                        border: 2px solid #23cc77;
                        border-radius: 100%;
                        background: #fff;
                    }
                }
            }
            &-table-summary {
                padding: 7px 10px 7px 0;
                font-size: 16px;
                color: $fontStrongColor;
                line-height: 24px;
                background: #fafafa;
                border-radius: 2px;
                dt {
                    float: left;
                }
                dd {
                    margin-left: 72px;
                    &.dt-table-act {
                        margin-left: 85px;
                    }
                }
            }
        }
        .dt-icon-t {
            display: inline-block;
            margin-right: 5px;
            width: 18px;
            height: 18px;
            border-radius: 100%;
            background: #000;
            i {
                position: relative;
                display: block;
                left: 1px;
                color: #fff;
                transform: scale(1.3);
            }
        }
    }
    /*-------------行程概要 e--------------*/

    /*-------------行程资源线 s--------------*/
    .journeys-resource {
        .journeys-dt {
            > ul > li {
                padding: 0;
                background-color: inherit;
            }
            &-container {
                margin-top: 0;
            }
            &-item {
                margin: 0 0 9px;
                padding: 15px 15px 15px 45px;
                background-color: #fff;
                border: 0;
            }
        }
    }
    /*-------------行程资源线 e--------------*/

    /*-------------行程目录预览 s--------------*/
    .journeys-overview {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 101;
        display: none;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 25px;
        width: 90%;
        height: 100%;
        background: rgba(45, 52, 65, 0.9);
        color: #edeef0;
        font-size: 14px;
        overflow-y: auto;
        &-space {
            position: fixed;
            left: 0;
            top: 0;
            height: 100%;
            width: 10%;
        }
        &-title {
            margin-left: -10px;
            font-size: 16px;
        }
        li {
            position: relative;
            padding-left: 20px;
            height: 22px;
            border-left: 1px solid #bbb;
            line-height: 22px;
            &:first-child {
                border-left: 0;
            }
        }
        &-content {
            height: auto;
            span {
                position: absolute;
                top: -4px;
                left: -15px;
                display: block;
                width: 25px;
                height: 25px;
                border: 1px solid #bbb;
                border-radius: 100%;
                background-color: #414753;
                color: #bbb;
                text-align: center;
                line-height: 25px;
            }
        }
    }
    /*-------------行程目录预览 e--------------*/

    /*-------------大图预览 s--------------*/
    .journeys-imglist {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #222;
        color: #fff;
        z-index: 101;
        &-header {
            position: relative;
            height: 50px;
            z-index: 10;
            h4 {
                display: inline-block;
                position: absolute;
                left: 50px;
                right: 50px;
                font-size: 16px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
            .journeys-imglist {
                &-back {
                    font-family: initial;
                    font-size: 25px;
                    display: inline-block;
                    padding: 11px 15px;
                }
                &-share {
                    display: inline-block;
                    position: absolute;
                    right: 0;
                    font-size: 20px;
                    padding: 15px;
                }
            }
        }
        &-container {
            height: 100%;
            img {
                width: 100%;
                position: absolute;
                top: 50%;
                -webkit-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            ul {
                height: 100%;
                li {
                    position: relative;
                    float: left;
                    height: 100%;
                    margin-top: -50px;
                }
            }
        }
        &-footer {
            position: absolute;
            width: 100%;
            bottom: 0;
            font-size: 16px;
            margin: 0 auto;
            height: 50px;
            line-height: 50px;
            text-align: center;
            padding: 0 15px;
            box-sizing: border-box;
            .journeys-imglist {
                &-title {
                    float: left;
                }
                &-page {
                    float: right;
                    b {
                        font-weight: normal;
                    }
                }
            }
        }
    }
    /*-------------大图预览 e--------------*/


    .journeys-switch {
        display: block;
        position: relative;
        background: #fff;
        z-index: 1;
        line-height: 32px;
        height: 32px;
        text-align: center;
        color: #28bf5d;
        font-size: 1.4rem;
        &.J_detail i {
            vertical-align: middle;
            display: inline-block;
            -webkit-transform: rotate(-180deg);
            -ms-transform: rotate(-180deg);
            transform: rotate(-180deg);
            -webkit-transform-origin: 50% 40%;
            -ms-transform-origin: 50% 40%;
            transform-origin: 50% 40%;
        }
    }
    .journeys-dt-item a.J_showDetail b {
        font-weight: normal;
        color: $greenColor;
    }

    .journeys-change {
        padding: 20px 0;
        text-align: center;
        background-color: #fff;
        &-btn {
            display: inline-block;
            width: 110px;
            height: 30px;
            border: 1px solid $greenColor;
            color: $greenColor;
            font-size: 13px;
            text-align: center;
            line-height: 30px;
            border-radius: 2px;
            touch-action: manipulation;
        }
    }
}
/*-------------行程tab s--------------*/
.journeys-title{
    height: 24px;
    font-size: 20px;
    color: $fontStrongColor;
    margin-bottom: 12px;
}
.journeys-tab {
    position: absolute;
    height: 42px;
    font-size: 14px;
    color: $fontStrongColor;
    white-space: nowrap;
    &-hold {
        height: 52px;
    }
    &-container {
        position: relative;
        width: 100%;
        overflow-x: hidden;
        background-color: #fff;
        height: 52px;
        &.fixed {
            position: fixed;
            top: 0;
            z-index: 10;
            margin-top: 44px;
            @at-root{
                #{'.app'} & {
                    margin-top: 0;
                }
            }
        }
    }
    li {
        display: inline-block;
        padding: 0 3px 10px 3px;
        height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        span {
            display: inline-block;
            box-sizing: border-box;
            padding: 0 20px;
            border-radius: 6px;
            height: 32px;
            line-height: 30px;
            border: 1px solid #b7c3ca;
        }
        &.active {
            position: relative;
            span {
                color: #fff;
                background-color: $greenColor;
                border-color: $greenColor;
            }
            &:after {
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%) translateY(11px);
                border: 11px solid transparent;
                border-top: 11px solid $greenColor;
            }
        }
    }
}
 .dt {
    &-item {
        &-title {
            position: relative;
            color: $greenColor;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
            span {
                float: left;
            }
            p {
                color: #222;
                margin-left: 50px;
            }
            a b {
                font-weight: normal;
                color: #222;
            }
        }
        &-des {
            margin: 10px 0 8px;
            touch-action: manipulation;
            &-content {
                font-size: 15px;
                font-weight: 300;
                line-height: 23px;
                color: $fontStrongColor;
                img {
                    max-width: 100%;
                    background:#e6e6e6;
                    border-radius: 9px;
                }
            }
            &-container {
                max-height: 128px;
                overflow: hidden;
            }
            #{'.expand'} & {
                &-container {
                    max-height: none;
                }
                &-expand {
                    background: none;
                    .icon-putaway {
                        transform: rotate(180deg) scale(3);
                    }
                }
            }
            &-expand {
                display: none;
                position: relative;
                text-align: center;
                background: #fff;
                background: linear-gradient(top, rgba(255, 255, 255, 0), #fff 40%,#fff);
                background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #fff 40%, #fff);
                margin-top: -14px;
                padding-top: 13px;
                color: #999;
                span {
                    display: inline-block;
                    transform: scale(3);
                }
                #{'.ellipsis'} & {
                    display: block;
                }
            }
        }
        &-remark {
            &-container {
                overflow: hidden;
            }
            #{'.expand'} & {
                &-container {
                    max-height: none;
                }
            }
        }
        &-content {
            #{&} &-title {
                font-size: 14px;
                line-height: 21px;
                color: #222;
                margin: 15px 0 10px;
                a b {
                    font-weight: normal;
                    color: #222;
                }
            }
        }
        &-scenic {
            margin-top: 10px;
            &-extra {
                position: relative;
                font-size: 12px;
                line-height: 18px;
                color: #666;
                background-color: #f5fafc;
                padding: 7px 9px;
                margin: 10px 0;
                &:before {
                    content: '';
                    position: absolute;
                    top: -9px;
                    left: 0;
                    display: block;
                    width: 0;
                    height: 0;
                    border: 9px solid transparent;
                    border-left: 9px solid #f5fafc;
                }
                dt {
                    float: left;
                }
                dd {
                    margin-left: 60px;
                }
            }
        }
        &-hotel {
            .dt-item-content-title {
                span {
                    float: left;
                    font-size: 12px;
                    color: #999;
                    left: -25px;
                }
            }
        }
        &-shopping {
            margin-top: 10px;
        }
        &-table {
            font-size: 12px;
            line-height: 18px;
            color: #666;
            padding: 7px 9px;
            border: 1px dashed #ddd;
            margin: 10px 0;
            dt {
                float: left;
            }
            dd {
                margin-left: 60px;
            }
        }
    }
    &-icon {
        position: absolute;
        left: -28px;
        top: 1px;
        width: 18px;
        height: 18px;
        font-size: 24px;
        text-indent: -3px;
        background-color: $greenColor;
        color: #fff;
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        line-height: 18px;
        &-traffic {
            margin: 0 5px;
            font-size: 12px;
            color: rgba(95,100,110,0.40);
            &-t {
                font-size: 14px;
                color:#999;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Journey.vue